// src/AnalyticsTracker.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "./components/utils/firebase";

const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;
        const start = Date.now();

        // Fire page_view
        analytics.logEvent("page_view", {
            page_path: path,
            page_title: `KTS3 - ${path}`,
        });

        return () => {
            const timeSpent = (Date.now() - start) / 1000;
            analytics.logEvent("time_on_page", {
                page_path: path,
                page_title: `KTS3 - ${path}`,
                time_spent_seconds: timeSpent,
            });
        };
    }, [location]);

    return null;
};

export default AnalyticsTracker;